import Burger from './Burger';
import BurgerContainer from './Burger.container';
export default BurgerContainer(Burger);
